import React, { useState, useEffect } from 'react';
import Dashboard from '../Dashboard/Dashboard';
import axios from 'axios';
import './Contact.css';
import { Helmet } from 'react-helmet';
import { END_URL, IMG_URL } from "../../config.js";



function Contact() {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        country: '',
        message: '',
    });

    const [validationErrors, setValidationErrors] = useState({});
    const [modalMessage, setModalMessage] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [countries, setCountries] = useState([]);

    const [Contact, setContact] = useState([]);

    const [seo, setSeo] = useState({});

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
        setValidationErrors({ ...validationErrors, [e.target.id]: '' }); // clear error on change
    };

    const validateForm = () => {
        const errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!formData.first_name.trim()) errors.first_name = 'First name is required';
        if (!formData.last_name.trim()) errors.last_name = 'Last name is required';
        if (!formData.email.trim()) {
            errors.email = 'Email is required';
        } else if (!emailRegex.test(formData.email)) {
            errors.email = 'Invalid email address';
        }
        if (!formData.country.trim()) {
            errors.country = 'country is required';
        }
        if (!formData.message.trim()) errors.message = 'Message is required';

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };


    useEffect(() => {
        const GetContactDetail = async () => {
            try {
                const response = await axios.get(`${END_URL}/contact`);

                setContact(response?.data?.contact_detail);
                
                setSeo(response.data.seo_page);

            } catch (error) {
                console.error("Failed to fetch countries:", error);
            }
        };

        GetContactDetail();
    }, []);

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                const response = await axios.get(`${END_URL}/countries`);

                if (
                    response.data &&
                    response.data.countries &&
                    Array.isArray(response.data.countries)
                ) {
                    const countryNames = response.data.countries
                        .map((country_id) => country_id.name.common)
                        .sort((a, b) => a.localeCompare(b));

                    setCountries(response.data.countries);
                } else {
                    console.error("Data is not in the expected format:", response.data);

                    setCountries([]);
                }
            } catch (error) {
                console.error("Failed to fetch countries:", error);
            }
        };

        fetchCountries();
    }, []);


    const handleSubmit = async (e) => {

        e.preventDefault();

        if (!validateForm()) {
            return;
        }

        try {
            const response = await axios.post(`${END_URL}/contact`, formData);
            console.log(response.data);

            setModalMessage(true);

            setModalVisible(true);
            setFormData({
                first_name: '',
                last_name: '',
                email: '',
                country: '',
                message: '',
            });
            setValidationErrors({});
        } catch (error) {
            console.error('There was an error submitting the form:', error);
            setModalMessage(false);
            setModalVisible(true);
        }
    };

    return (
        <>

        <Helmet>
            <title>
                {seo?.meta_title ||
                "PersonalityTest - Discover Your True Archetype | Personality Peek"}
            </title>
    
            <meta
                name="description"
                content={
                seo?.meta_description ||
                "Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey."
                }
            />
    
            <meta
                name="keywords"
                content={
                seo?.meta_keywords ||
                "personality assessment test , personality test"
                }
            />
    
            {seo?.og_title && <meta property="og:title" content={seo.og_title} />}
            {seo?.og_description && (
                <meta property="og:description" content={seo.og_description} />
            )}
            {seo?.og_image && (
                <meta property="og:image" content={`${IMG_URL}/d0/${seo.og_image}`} />
            )}
            {seo?.og_url && <meta property="og:url" content={seo.og_url} />}
            {seo?.og_type && <meta property="og:type" content={seo.og_type} />}
    
            {seo?.twitter_title && (
                <meta name="twitter:title" content={seo.twitter_title} />
            )}
            {seo?.twitter_description && (
                <meta name="twitter:description" content={seo.twitter_description} />
            )}
            {seo?.twitter_image && (
                <meta
                name="twitter:image"
                content={`${IMG_URL}/d0/${seo.twitter_image}`}
                />
            )}
            {seo?.twitter_card && (
                <meta name="twitter:card" content={seo.twitter_card} />
            )}
    
            {seo?.og_url && <link rel="canonical" href={seo.og_url} />}
    
            {!seo?.og_title && (
                <meta
                property="og:title"
                content="PersonalityTest - Discover Your True Archetype | Personality Peek"
                />
            )}
            {!seo?.og_description && (
                <meta
                property="og:description"
                content="Take the Personality Test at Personality Peek. Discover your true archetype, unlock insights and start your self-discovery journey."
                />
            )}
            {!seo?.og_type && <meta property="og:type" content="website" />}
            {!seo?.twitter_card && (
                <meta name="twitter:card" content="summary_large_image" />
            )}

        </Helmet>


            <div>
                <div className='result-cont contact-page'>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">
                                <Dashboard />
                            </div> */}
                            <div className="col-12 col-sm-12 col-md-9 col-lg-9">
                                <div className="contact-form">

                                    <span className='contact-header' dangerouslySetInnerHTML={{ __html: Contact?.contact_content_1 }} />

                                    <form onSubmit={handleSubmit} noValidate>
                                        <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label htmlFor="first_name">First Name <span style={{ color: 'red' }}>*</span> </label>
                                                <input type="text" className="form-control" id="first_name" value={formData.first_name} onChange={handleChange} />
                                                {validationErrors.first_name && <small className="text-danger">{validationErrors.first_name}</small>}
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label htmlFor="last_name">Last Name  <span style={{ color: 'red' }}>*</span> </label>
                                                <input type="text" className="form-control" id="last_name" value={formData.last_name} onChange={handleChange} />
                                                {validationErrors.last_name && <small className="text-danger">{validationErrors.last_name}</small>}
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label htmlFor="email">Email  <span style={{ color: 'red' }}>*</span> </label>
                                                <input type="email" className="form-control" id="email" value={formData.email} onChange={handleChange} />
                                                {validationErrors.email && <small className="text-danger">{validationErrors.email}</small>}
                                            </div>

                                            <div className="form-group col-md-6">

                                                <label htmlFor="country">Country <span style={{ color: 'red' }}>*</span> </label>

                                                <select className="form-control" value={formData.country} id="country" onChange={handleChange} >

                                                    <option value="">Select Country</option>
                                                    {countries.map((country) => (
                                                        <option key={country.id} value={country.name}>
                                                            {country.name}
                                                        </option>
                                                    ))}
                                                </select>

                                                {validationErrors.country && <small className="text-danger">{validationErrors.country}</small>}
                                            </div>


                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="message">Message  <span style={{ color: 'red' }}>*</span> </label>
                                            <textarea className="form-control" id="message" rows="5" value={formData.message} onChange={handleChange}></textarea>
                                            {validationErrors.message && <small className="text-danger">{validationErrors.message}</small>}
                                        </div>
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </form>

                                    <div class="contact-section">


                                    <span className='contact-footer' dangerouslySetInnerHTML={{ __html: Contact?.contact_content_2 }} />
                                

                                        {Contact && (Contact?.contact_email || Contact?.contact_phone) && (

                                            <div className="contact-detail">

                                                {Contact?.contact_email && (

                                                    <div>
                                                        <span>Email</span>
                                                        <a href={`mailto:${Contact?.contact_email}`} >{Contact?.contact_email}</a>
                                                    </div>
                                                )}

                                            {Contact?.contact_phone && (
                                                    <div>
                                                        <span>Phone:</span>
                                                        {(() => {
                                                        const cleanedPhone = Contact.contact_phone
                                                            ?.trim()                      
                                                            ?.replace(/[^\d]/g, "");   

                                                        return cleanedPhone ? (
                                                            <a href={`tel:${cleanedPhone}`}>{Contact.contact_phone}</a>
                                                        ) : (
                                                            <span></span>
                                                        );
                                                        })()}
                                                    </div>
                                                )}


                                            </div>

                                        )}


                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {modalVisible && (
                    <div className="modal fade show contact-modal" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content contact-modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{Contact?.contact_success_email_title}</h5>
                                    <button type="button" className="close" onClick={() => setModalVisible(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>

                                    {Contact?.contact_success_email_content && (

                                        <div className="modal-body" dangerouslySetInnerHTML={{ __html:Contact?.contact_success_email_content }}/>
                                    )}
                                
                            </div>
                        </div>
                    </div>
                )}
            </div>

        </>

    );
}

export default Contact;
